import { useMutation } from '@tanstack/react-query';

import { freemiumApi } from '@client/api/waterlily';

export function useFreemiumDetails(clientId: string) {
  return useMutation({
    mutationFn: (details: string) => freemiumApi.postDetails(clientId, { details: details.trim() }),
  });
}
